export default __webpack_public_path__ + "static/media/Roboto-Medium.f59e001b.woff";